/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import { Component, Input } from '@angular/core';
import { ClarityIcons } from '@cds/core/icon';

import { ICON_SETS, IconSet } from './icon-inventory';

export interface IconGroupsFormOptions {
  searchTerm: string;
  solid: boolean;
  badge: string;
}

@Component({
  selector: 'app-icon-groups',
  templateUrl: './icon-groups.component.html',
  styleUrls: ['./icon-groups.component.scss'],
})
export class IconGroupsComponent {
  @Input() formOptions: IconGroupsFormOptions;

  iconSets: IconSet[];
  selectedIcon: string;

  constructor() {
    ClarityIcons.addIcons(...ICON_SETS.map(iconSet => iconSet.icons).flat());
  }

  onIconClick(iconName: string) {
    if (this.selectedIcon === iconName) {
      this.selectedIcon = undefined;
    } else {
      this.selectedIcon = iconName;
    }
  }
}
